<script>
import { reportListMethod } from '@state/helpers'
import { ErrorWrapper } from '@utils/error-handler'
// import VueDropify from 'vue-dropify'
export default {
  props: {
    data: {
      type: Object,
      required: true,
      default: () => {},
    },
  },
  // components: {'vue-dropify': VueDropify },
  data() {
    return {
      title: '',
      document: '',
      description: '',
      error: null,
      reportRequest: false,
      isChangeError: false,
      isSuccess: false,
      successMessage: null,
      prevent: null,
      isReportError: false,
      reportError: false,
      reportSuccess: '',
      isLoading: false,
    }
  },
  computed: {},
  methods: {
    ...reportListMethod,
    requestReport() {
      let self = this
      self.isLoading = true
      const report = {
        document: this.document,
        id: self.data._id,
      }
      this.updateReportRequest({ report })
        .then((reportrequest) => {
          self.isLoading = false
          this.title = ''
          this.description = ''
          this.reportSuccess = 'Report Uploaded Successfully'
          this.isSuccess = true
          window.location.reload()
        })
        .catch((error) => {
          self.isLoading = false
          this.title = ''
          this.description = ''
          this.isLoading = false
          var getError = new ErrorWrapper(error)
          this.reportError = getError.message
          this.isReportError = true
        })
    },
    resetModal() {
      this.title = ''
      this.description = ''
      this.reportSuccess = ''
      this.isSuccess = false
      this.isReportError = false
      this.reportError = ''
    },
    uploadImage(event) {
      var reader = new FileReader()
      reader.readAsDataURL(event[0])
      reader.onload = () => {
        this.document = reader.result
      }
    },
    handleFileUpload(event) {
      var files = event.target.files || event.dataTransfer.files
      const reader = new FileReader()
      reader.readAsDataURL(files[0])
      reader.onload = () => {
        this.document = reader.result
      }
    },
  },
}
</script>
<template>
  <b-modal
    id="upload-modal"
    title="Upload Report"
    :hide-footer="true"
    @hidden="resetModal"
  >
    <b-overlay :show="isLoading" :opacity="0.6" rounded="sm">
      <b-form @submit.prevent="requestReport">
        <b-alert
          v-model="isReportError"
          variant="danger"
          v-html="reportError"
        ></b-alert>
        <b-alert
          v-model="isSuccess"
          variant="success"
          v-html="reportSuccess"
        ></b-alert>
        <b-form-group label="Select Report" label-for="document">
          <b-form-file
            id="document"
            ref="file"
            type="file"
            required
            placeholder="Select Report"
            accept="application/vnd.ms-excel"
            @change="handleFileUpload"
          ></b-form-file>
        </b-form-group>
        <b-form-group id="button-group" class="mt-2">
          <b-button type="submit" variant="primary" class="btn-block button"
            >Upload</b-button
          >
        </b-form-group>
      </b-form>
    </b-overlay>
  </b-modal>
</template>
<style>
.button {
  width: 100px;
  background-color: skyblue;
}
.modal-backdrop {
  opacity: 0.5;
}
</style>
